module.exports = __webpack_public_path__ + "static/about-us-72a6eb18319903e831838a76c6e81530.png";